<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.cover_image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library
							:height="300"
							v-model="item.cover_image"
						></app-media-library>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							v-slot="{ errors, valid }"
						>
							<form-localized-input
								v-model="item.name"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-input>
						</ValidationProvider>
					</v-flex>
					<!-- <v-flex xs12>
						<ValidationProvider
							name="cuisine_ids"
							v-slot="{ errors, valid }"
						>
							<v-autocomplete
								v-model="item.cuisine_ids"
								:items="cuisines"
								item-value="id"
								item-text="name"
								:label="$t('label.cuisines')"
								multiple
								:errors="errors"
								:valid="valid"
								filled
							></v-autocomplete>
						</ValidationProvider>
					</v-flex> -->
					<v-flex xs12>
						<ValidationProvider
							name="name"
							v-slot="{ errors, valid }"
						>
							<form-localized-editor
								v-model="item.description"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-editor>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<v-layout row wrap>
					<v-flex xs12>
						<v-card>
							<v-card-title primary-title>
								<h3>{{ $t("label.logo") }}</h3>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<app-media-library
									v-model="item.image"
								></app-media-library>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>

			<v-flex xs12 v-if="item.settings">
				<v-card>
					<v-card-title primary-title>
						{{ $t("Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.reservation_module"
									:label="$t('Reservation Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.delivery_module"
									:label="$t('Delivery Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.pickup_module"
									:label="$t('Pickup Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.dine_in_module"
									:label="$t('Dinein Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.review_module"
									:label="$t('Review Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.discover_module"
									:label="$t('Discover Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.map_module"
									:label="$t('Map Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.check_menu_module"
									:label="$t('Menu Module')"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "cuisines"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>